import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment'
import { Driver } from "../constant/driver"
import { retry, catchError } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class DriverService {

  public apiUrl = environment.api

  constructor(
    private httpClient: HttpClient
  ) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-type': 'application/json'
    })
  }

  /**
   * getDrivers
   */
  public getDrivers(): Observable<Driver> {
    return this.httpClient.get<Driver>(
      this.apiUrl + 'drivers/getAll',
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }

  /**
   * getDriversByEntreprise
   */
  public getDriversByEntreprise(data): Observable<Driver> {
    return this.httpClient.post<Driver>(
      this.apiUrl + 'drivers/getAllByEntreprise',
      JSON.stringify(data),
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }

  /**
   * addDrivers
   */
  public addDrivers(data): Observable<Driver> {
    return this.httpClient.post<Driver>(
      this.apiUrl + 'drivers/add',
      JSON.stringify(data),
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }

  /**
   * updateDrivers
   */
  public updateDrivers(data): Observable<Driver> {
    return this.httpClient.post<Driver>(
      this.apiUrl + 'drivers/update',
      JSON.stringify(data),
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }

  /**
   * deleteDrivers
   */
  public deleteDrivers(data): Observable<Driver> {
    return this.httpClient.post<Driver>(
      this.apiUrl + 'drivers/delete',
      JSON.stringify(data),
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }

  // Error handling
  public handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(['Erreur HTTP', errorMessage]);
    return throwError(errorMessage);
  }
}
